import { Button, Tooltip } from 'antd';
import type { ExpenseView } from '../expenses.api';
import { DECISION_LABELS, decisionBlockedReason, type DecisionMode } from '../policies/expense-decision';

interface ExpenseDecisionButtonsProps {
  expense: ExpenseView;
  onDecide: (mode: DecisionMode, expense: ExpenseView) => void;
}

const MODES: DecisionMode[] = ['approve', 'reject', 'exception'];

/** A button that is not offered says why on hover, so the approver is not left guessing: a disabled button swallows pointer events, hence the wrapper. */
export function ExpenseDecisionButtons({ expense, onDecide }: ExpenseDecisionButtonsProps) {
  return (
    <div className="flex gap-2">
      {MODES.map((mode) => {
        const blockedReason = decisionBlockedReason(mode, expense);
        return (
          <Tooltip key={mode} title={blockedReason}>
            <span>
              <Button size="small" danger={mode === 'reject'} disabled={blockedReason !== null} onClick={() => onDecide(mode, expense)}>
                {mode === 'exception' ? 'Exception' : DECISION_LABELS[mode]}
              </Button>
            </span>
          </Tooltip>
        );
      })}
    </div>
  );
}
